<template>
  <pop-up
    title="Add Restream"
    button-text="Submit"
    :disabled="loading || invalidForm"
    :spinning="loading"
    class="top-fade-in popup"
    @add="validateForm"
    @close="$emit('close')"
  >
    <transition
      name="fade"
      mode="out-in"
    >
      <div class="restream-table-wrapper">
        <loading-page
          v-if="loading"
          class="loading"
        />
        <div v-else>
          <validation-observer ref="restreamForm">
            <div class="container m-0">
              <validation-provider
                #default="{ errors }"
                name="serverURL"
                rules="required|min:3|max:50"
              >
                <input-field
                  label="Server URL*"
                  label-position="top"
                  :error="errors.length ? errors[0] : null"
                >
                  <b-form-input
                    v-model.trim="serverURL"
                    placeholder="Add URL here..."
                    :state="errors.length > 0 ? false : null"
                  />
                </input-field>
              </validation-provider>
              <validation-provider
                #default="{ errors }"
                name="serverKey"
                rules="required|min:3|max:50"
              >
                <input-field
                  label="Server Key*"
                  label-position="top"
                  :error="errors.length ? errors[0] : null"
                >
                  <b-form-input
                    v-model.trim="serverKey"
                    placeholder="Add stream Key here..."
                    :state="errors.length > 0 ? false : null"
                  />
                </input-field>
              </validation-provider>
            </div>
          </validation-observer>
        </div>
      </div>
    </transition>
  </pop-up>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import PopUp from '@/components/popup/Pop-up.vue'

export default {
  name: 'RestreamForm',
  components: {
    PopUp,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      required,
      serverURL: null,
      serverKey: '',
      restream: null,
      showServerKey: false,
    }
  },
  computed: {
    loading() {
      return this.loadingRestream || this.updatingRestream || this.creatingRestream
    },
    loadingRestream() {
      return this.$store.state.restreams.fetchingRestreams
    },
    updatingRestream() {
      return this.$store.state.restreams.updatingRestream
    },
    creatingRestream() {
      return this.$store.state.restreams.creatingRestream
    },
    invalidForm() {
      return this.isNullOrEmpty(this.serverURL) || this.isNullOrEmpty(this.serverKey)
    },
  },
  methods: {
    validateForm() {
      return new Promise((resolve, reject) => {
        this.$refs.restreamForm.validate().then(success => {
          if (success) {
            this.submit()
            resolve(true)
          } else {
            this.errorToast('Check if all fields are valid!')
            reject()
          }
        })
      })
    },
    submit() {
      const restream = {
        serverURL: this.serverURL,
        serverKey: this.serverKey,
      }
      this.$emit('submit', restream)
    },
  },
}
</script>

<style lang="scss" scoped>
.popup::v-deep{
  .popup {
    .popup__body{
      padding-top: 1rem;
      padding-bottom: 1rem;
    }
  }
}
.restream-table-wrapper {
  .loading::v-deep {
    padding: 2.4rem !important;
  }
  .details {
    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.2s ease;
    }
    .fade-enter-from,
    .fade-leave-to {
      opacity: 0;
    }
  }
}
</style>
